import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiPhone, FiMapPin } = FiIcons;

const ResumeHeader = ({ personal }) => {
  return (
    <header className="border-b-4 border-slate-800 pb-6 mb-8">
      <h1 className="text-4xl md:text-5xl font-bold text-slate-900 tracking-tight">
        {personal.firstName} {personal.lastName}
      </h1>
      <h2 className="text-xl md:text-2xl text-blue-700 font-semibold mt-2">
        {personal.title}
      </h2>
      {personal.subTitle && (
        <p className="text-md text-slate-600 font-medium mt-1">
          {personal.subTitle}
        </p>
      )}
      <div className="flex flex-wrap gap-4 md:gap-6 mt-4 text-sm font-medium text-slate-700">
        <a href={`mailto:${personal.email}`} className="flex items-center gap-2 hover:text-blue-600 transition-colors">
          <SafeIcon icon={FiMail} className="text-blue-600" />
          {personal.email}
        </a>
        <a href={`tel:${personal.phone}`} className="flex items-center gap-2 hover:text-blue-600 transition-colors">
          <SafeIcon icon={FiPhone} className="text-blue-600" />
          {personal.phone}
        </a>
        <span className="flex items-center gap-2">
          <SafeIcon icon={FiMapPin} className="text-blue-600" />
          {personal.city}, {personal.state} {personal.zip}
        </span>
      </div>
    </header>
  );
};

export default ResumeHeader;